import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const footerClasses = {
  root: css`
    overflow: hidden;
    z-index: 35;
    border-radius: ${spacing(2.5, 2.5, 0, 0)};
    color: ${cssTheme.default.day.everWhite};
    background: ${cssTheme.colors.deliveryGrey[500]};
    display: flex;
    justify-content: center;
    padding: ${spacing(7.125, 6.625, 6.625, 6.625)};
    box-sizing: border-box;
    margin-block-start: ${spacing(-1.875)};
  `,
  footerContainer: css`
    inline-size: 100%;
    display: grid;
    gap: ${spacing(6.25)};
  `,
  firstLine: css`
    & > *:not(:last-child) {
      margin-inline-end: ${spacing(12.5)};
    }
  `,
  separator: css`
    opacity: 0.1;
    border-block-end: ${spacing(0.25)} solid #a6a6a6;
  `,
  logoContainer: css`
    max-inline-size: fit-content;
  `,
  appContainer: css`
    flex-basis: 0;
    block-size: auto;
  `,
  navigation: css`
    margin-block-end: ${spacing(8)};
  `,
  legal: css`
    color: #f2f2f2;
    opacity: 0.6;

    margin-block-end: ${spacing(4.625)};

    & > *:first-child {
      margin-block-end: ${spacing(2)};
    }
  `,
  legalLinks: css`
    margin-block-end: ${spacing(8.25)};

    & > *:not(:last-child) {
      margin-inline-end: ${spacing(2.5)};
    }
  `,
  caption1: css`
    font-size: ${spacing(1.75)};
    line-height: ${spacing(2.5)};
  `,
}
